import React, { Component } from 'react'
import { render } from 'react-dom'

import { InlineMath, BlockMath } from 'react-katex';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark, darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';

import {
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

class Chapter100 extends Component {
  render() {
    return (
      <div className="base">

        <Header as='h1'>
        1. 確率理論の導入とプレファレンスの数学的説明
        </Header>

        <Header as='h2'>
        マーケティングにおける確率分布
        </Header>

　限られた時間の中で生きている我々が知ることが出来るのは、平均値とその分散（標準偏差）のみです。マーケティングの世界で例えると、一日あたりの来店者数、一日あたりの商品の売り上げ数などです。では、その限られた情報から何を知ることが出来るでしょうか？今日の来店者数が１０００人だった場合、明日の来店者数が５００の確率はどのぐらいでしょうか？また、１５００人である確率はどのぐらいでしょうか？その答えを教えてくれるのが確率分布になります。 <br/>

　「確率思考の戦略論」では、確率分布の形状を決める平均値と標準偏差に相当する数字を <InlineMath>{`\\displaystyle M `}</InlineMath>と<InlineMath>{`\\displaystyle K `}</InlineMath>という二つのパラメタで表現できるとしています。<InlineMath>{`\\displaystyle M `}</InlineMath>が消費者のプリファレンス（相対的好意度）そのものであり、<InlineMath>{`\\displaystyle K `}</InlineMath>は<InlineMath>{`\\displaystyle M `}</InlineMath>の関数です。本書では一貫して以下の事を主張しています。 <br/>

<div className="box2"><p> プリファレンス（相対的好意度）がブランドのマーケット・シェア、浸透率、購入回数を支配している </p></div>

　理由は以下の3点です（教科書の写し書きです）。

<ol>
  <li>プリファレンスは消費者の頭の中にあり、人の購買行動を支配している。直接的な証拠は、消費者のプリファレンスに基づく「BP-10シェアモデル」が現実のシェアを比較的高い精度で予測できる事である。<font color="MediumVioletRed">消費者のプリファレンスがシェアを支配し、売り上げを支配している。</font>言い換えれば、100%の認知、100%の配下率、十分な時間があればプリファレンスとユニット・シェアは同じものになる。プレファレンスは消費者の頭の中にあり、それが現実に現れたのがユニット・シェアである。</li>
  <li>負の二項分布モデルにより、カテゴリーおよびブランドの浸透率と回数別分布は、<InlineMath>{`\\displaystyle M `}</InlineMath>と<InlineMath>{`\\displaystyle K `}</InlineMath>の二つのパラメタのみで現実に非常に近い正確な予測が出来る。<InlineMath>{`\\displaystyle M `}</InlineMath>も<InlineMath>{`\\displaystyle K `}</InlineMath>もプリファレンスの関数である。</li>
  <li>カテゴリーの<InlineMath>{`\\displaystyle M `}</InlineMath>と<InlineMath>{`\\displaystyle K `}</InlineMath>、ユニット・シェア、デリシュレー<InlineMath>{`\\displaystyle S `}</InlineMath>をインプットとして、デリシュレーNBDモデルは各ブランドの現実に非常に近い浸透率と回数別購入率の分布を正確に予測する事が出来る。ブランド間のスイッチングも正確に予測できる。デリシュレー<InlineMath>{`\\displaystyle S `}</InlineMath>も<InlineMath>{`\\displaystyle K `}</InlineMath>もプリファレンスの関数である。</li>
</ol>

　本サイトでは、「確率思考の戦略論」にそって

<ol>
  <li>二項分布</li>
  <li>ポアソン分布</li>
  <li>負の二項分布</li>
  <li>ポアソン分布と負の二項分布のまとめ</li>
  <li>売り上げを支配する重要な式</li>
  <li>デリシュレーNBDモデル</li>
</ol>

の順に沿って解説を行います。



      </div>
    )   
  }
}

export default Chapter100;
